import React, { useState } from 'react';
import './Feedback.css';
const FeedbackForm = () => {
	// Form state
	const [formData, setFormData] = useState({
		email: '',
		subject: '',
		content: ''
	});

	// Error state
	const [errors, setErrors] = useState({});

	// Submission state
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [submitSuccess, setSubmitSuccess] = useState(false);

	// Handle input changes
	const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData({
			...formData,
			[name]: value
		});

		// Clear corresponding field error
		if (errors[name]) {
			setErrors({
				...errors,
				[name]: ''
			});
		}
	};

	// Validate form
	const validateForm = () => {
		const newErrors = {};

		// Validate email
		if (!formData.email) {
			newErrors.email = 'Please enter an email address';
		} else if (!/\S+@\S+\.\S+/.test(formData.email)) {
			newErrors.email = 'Please enter a valid email address';
		}

		// Validate subject
		if (!formData.subject) {
			newErrors.subject = 'Please enter a subject';
		} else if (formData.subject.length < 5) {
			newErrors.subject = 'Subject must be at least 5 characters';
		}

		// Validate content
		if (!formData.content) {
			newErrors.content = 'Please enter your feedback';
		} else if (formData.content.length < 10) {
			newErrors.content = 'Content must be at least 10 characters';
		}

		setErrors(newErrors);
		return Object.keys(newErrors).length === 0;
	};

	// Submit form
	const handleSubmit = async (e) => {
		e.preventDefault();

		// Validate form
		if (!validateForm()) {
			return;
		}

		setIsSubmitting(true);

		try {
			// Replace with actual API call
			// Example: const response = await axios.post('/api/feedback', formData);

			// Simulate API call
			await new Promise(resolve => setTimeout(resolve, 1000));

			// Submission successful
			setSubmitSuccess(true);

			// Reset form
			setFormData({
				email: '',
				subject: '',
				content: ''
			});

		} catch (error) {
			console.error('Submission failed:', error);
			setErrors({ submit: 'Submission failed, please try again later' });
		} finally {
			setIsSubmitting(false);
		}
	};

	// Reset form for new submission
	const handleReset = () => {
		setSubmitSuccess(false);
	};

	// If form submission is successful, show success message
	if (submitSuccess) {
		return (
			<div className="feedback-success">
				<h2>Thank you for your feedback!</h2>
				<p>We've received your message and will process it soon.</p>
				<button onClick={handleReset}>Submit Again</button>
			</div>
		);
	}

	return (
		<div className="feedback-container">
			<h2>Feedback Form</h2>
			<p>Please fill in the information below to help us improve our services</p>

			<form onSubmit={handleSubmit} className="feedback-form">
				<div className="form-group">
					<label htmlFor="email">Email Address *</label>
					<input
						type="email"
						id="email"
						name="email"
						value={formData.email}
						onChange={handleChange}
						placeholder="Please enter your email"
						className={errors.email ? 'error' : ''}
					/>
					{errors.email && <p className="error-message">{errors.email}</p>}
				</div>

				<div className="form-group">
					<label htmlFor="subject">Subject *</label>
					<input
						type="text"
						id="subject"
						name="subject"
						value={formData.subject}
						onChange={handleChange}
						placeholder="Please enter a subject"
						className={errors.subject ? 'error' : ''}
					/>
					{errors.subject && <p className="error-message">{errors.subject}</p>}
				</div>

				<div className="form-group">
					<label htmlFor="content">Feedback *</label>
					<textarea
						id="content"
						name="content"
						value={formData.content}
						onChange={handleChange}
						placeholder="Please describe your issue or suggestion in detail..."
						rows="5"
						className={errors.content ? 'error' : ''}
					/>
					{errors.content && <p className="error-message">{errors.content}</p>}
				</div>

				{errors.submit && <p className="error-message submit-error">{errors.submit}</p>}

				<button
					type="submit"
					className="submit-button"
					disabled={isSubmitting}
				>
					{isSubmitting ? 'Submitting...' : 'Submit Feedback'}
				</button>
			</form>
		</div>
	);
};

export default FeedbackForm;